import styled from "styled-components";

import { flexStart } from "../../style/reusableStyle";

export const SidebarWrapper = styled.div`
  position: fixed;
  top: 60px;
  left: 0;
  bottom: 0;

  width: fit-content;
  min-width: 260px;
  max-width: 420px;

  padding-right: 16px;
  padding-bottom: 20px;

  overflow-y: auto;
  overflow-x: hidden;

  z-index: ${({ theme }) => theme.zIndices.sidebar};
  background-color: ${({ theme }) => theme.colors.white};
  border-right: 1px solid #f0f0f0;

  &::-webkit-scrollbar {
    width: 0.4em;
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    min-width: 220px;
    max-width: 320px;
  }
`;

export const UserInfoContainer = styled.div`
  position: -webkit-sticky;
  position: sticky;
  top: 0px;
  background-color: ${({ theme }) => theme.colors.white};
  padding: 36px 10px 20px 16px;

  ${flexStart};
  gap: 12px;
  margin-bottom: 50px;

  & .info-wrapper {
    width: calc(100% - 88px - 12px - 20px);
  }

  @media (max-width: ${({ theme }) => theme.breakpoints.xl}) {
    padding: 36px 10px 20px 20px;
  }
  @media (max-width: ${({ theme }) => theme.breakpoints.md}) {
    padding: 36px 10px 20px 80px;
  }
`;
export const MenuListContainer = styled.div`
  & .children-container {
    margin: 18px 0 18px 32px;
  }
`;

export const ItemWrapper = styled.div<{
  $isItemSelected: boolean;
}>`
  ${flexStart};
  gap: 16px;

  padding-left: 16px;
  cursor: pointer;

  color: ${({ $isItemSelected, theme }) =>
    $isItemSelected ? theme.colors.secondary : theme.colors.normalText};

  /* 🔑 Important */
  white-space: normal;
  word-break: break-word;

  & span,
  & p {
    overflow-wrap: anywhere;
  }

  &:hover {
    color: ${({ theme }) => theme.colors.primary};
  }

  & + & {
    margin-top: 20px;
  }
`;

export const SmallScreenMenuContainer = styled.div`
  display: none;
  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: block;
  }
`;

export const LargeScreenMenuContainer = styled.div`
  display: block;
  @media (max-width: ${({ theme }) => theme.breakpoints.lg}) {
    display: none;
  }
`;
